// extracted by mini-css-extract-plugin
module.exports = {"iframe":"Cart_iframe_1EHaP","loader":"Cart_loader_Rqg0P"};